import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { HintWrapper } from './styles'

const SearchResultHint = ({ content }) => {
  const [hintContent, setHintContent] = useState(content)
  const [isDisplay, setIsDisplay] = useState(true)
  useEffect(() => {
    setHintContent(content)
  }, [content])
  if (isDisplay) {
    setTimeout(() => setIsDisplay(false), 7000)
  }
  return (
    <HintWrapper isDisplay={isDisplay} aria-live="polite">
      {hintContent}
    </HintWrapper>
  )
}

SearchResultHint.propTypes = {
  content: PropTypes.string,
}

export default SearchResultHint
